const config = {
  siteTitle: 'Apex Software',
  siteTitleShort: 'Apex Software',
  siteTitleAlt: 'Apex Software Silicon Valley, software solutions and ourtsourcing',
  siteLogo: '/logos/Group_1.png',
  siteUrl: 'https://apexsoftwaresiliconvalley.com',
  repo: 'https://github.com/sesv-tutorial',
  pathPrefix: '',
  dateFromFormat: 'YYYY-MM-DD',
  dateFormat: 'MMMM Do, YYYY',
  siteDescription:
    'Apex Software Silicon Valley, software solutions and ourtsourcing.',
  siteRss: '/rss.xml',
  googleAnalyticsID: 'G-K0R8JKQHS3',
  postDefaultCategoryID: 'Tech',
  newsletter: 'https://sesvtutorial.substack.com',
  newsletterEmbed: 'https://sesvtutorial.substack.com/embed',
  userName: 'SESV',
  userEmail: 'sesvtutorial@gmail.com',
  userTwitter: 'svsetutorial',
  menuLinks: [
    {
      name: 'About',
      link: '/about/',
    },
    {
      name: 'Services',
      link: '/services/',
    },
    {
      name: 'Blogs',
      link: '/blogs/',
    },
    {
      name: 'Contact',
      link: '/contact/',
    },
  ],
  themeColor: '#3F80FF', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff',
}

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === '/') {
  config.pathPrefix = ''
} else {
  // Make sure pathPrefix only contains the first forward slash
  config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, '')}`
}

// Make sure siteUrl doesn't have an ending forward slash
if (config.siteUrl.substr(-1) === '/') config.siteUrl = config.siteUrl.slice(0, -1)

// Make sure siteRss has a starting forward slash
if (config.siteRss && config.siteRss[0] !== '/') config.siteRss = `/${config.siteRss}`

module.exports = config
